import type { IconComponent } from 'src/icons/types';
import { AlertVariants } from './types';
import {
  CriticalIcon,
  HelpFillIcon,
  InfoFillIcon,
  RecommendIcon,
  SuccessFillIcon,
  WarningIcon,
} from '../../icons';

export const IconMap: Record<AlertVariants, IconComponent> = {
  default: InfoFillIcon,
  error: CriticalIcon,
  success: SuccessFillIcon,
  info: HelpFillIcon,
  warning: WarningIcon,
  recommend: RecommendIcon,
};
